import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebook, FaWhatsapp, FaPhone,
  FaEnvelope, FaMapMarkerAlt, FaClock
} from 'react-icons/fa';
import './Footer.css';
import ikmanLogo from '../images/ikman logo.jpeg';
import companyLogo from '../images/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src={companyLogo}
                alt="Kariyapperuma Car Sales"
                className="footer-logo-image"
              />
              <div className="footer-logo-text">
                <span>KARIYAPPERUMA</span>
                <small>Car Sales</small>
              </div>
            </div>
            <p className="footer-description">
              High Quality Unregistered Car Importer serving Sri Lanka since 2000.
              Your trusted partner for premium Japanese vehicle imports.
            </p>
            <div className="social-links">
              <a 
                href="https://www.facebook.com/KariyapperumaCarSales/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="https://wa.me/94707352969"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
              <a
                href="https://ikman.lk/en/shops/kariyapperuma-enterprises"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ikman.lk"
                className="ikman-link"
              >
                <img
                  src={ikmanLogo}
                  alt="ikman.lk"
                  className="ikman-logo"
                />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/vehicles">Our Vehicles</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Vehicle Categories</h3>
            <ul className="footer-links">
              <li><Link to="/vehicles?category=sedan">Sedans</Link></li>
              <li><Link to="/vehicles?category=suv">SUVs</Link></li>
              <li><Link to="/vehicles?category=hatchback">Hatchbacks</Link></li>
              <li><Link to="/vehicles?category=van">Vans & MPVs</Link></li>
            </ul>
          </div>
<div className="footer-section">
  <h3>Contact Info</h3>
  <ul className="footer-contact">
    <li>
      <FaMapMarkerAlt />
      <span>600/4A, Kandy Road, Eldeniya,<br />Kadawatha</span>
    </li>
    <li>
      <FaPhone />
      <span>+94 70 735 2969</span>
    </li>
    <li>
      <FaEnvelope />
      <span>Kariyapperumacars@gmail.com</span>
    </li>
    <li>
      <FaClock />
      <span>Mon-Sat: 6:00 AM - 9:00 PM</span>
    </li>
  </ul>
</div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Kariyapperuma Car Sales. All rights reserved.</p>
          <p className="footer-tagline">Member since 2000 | High Quality Unregistered Car Importer</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
